var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharpenMobile = function SvgSharpenMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M15.7856 6.81503C15.8827 6.65319 16.1173 6.65319 16.2144 6.81503L26.4482 23.8714C26.5482 24.038 26.4281 24.25 26.2338 24.25H5.76619C5.57187 24.25 5.45184 24.038 5.55182 23.8714L15.7856 6.81503Z"
  })));
};
export default SvgSharpenMobile;